/**
 * Minus/plus buttons for WooCommerce quantity inputs (see
 * craftis_quantity_stepper_minus()/_plus() in inc/woocommerce-hooks.php,
 * which print the buttons around every core-rendered qty <input>). Clicking
 * either button steps the adjacent input's value by its own min/max/step
 * attributes and dispatches a native "change" event so WooCommerce's own
 * cart-update and mini-cart scripts (which listen for that event) still
 * react normally — this only replaces how the value gets there, not what
 * happens after.
 */

function craftisStepQuantity( input, direction ) {
	if ( ! input || input.readOnly || input.disabled ) {
		return;
	}

	const step = parseFloat( input.step ) || 1;
	const min = input.min !== '' ? parseFloat( input.min ) : -Infinity;
	const max = input.max !== '' ? parseFloat( input.max ) : Infinity;
	const current = parseFloat( input.value ) || 0;

	const next = Math.min( max, Math.max( min, current + direction * step ) );

	if ( next === current ) {
		return;
	}

	input.value = next;
	input.dispatchEvent( new Event( 'change', { bubbles: true } ) );
}

function initQuantitySteppers() {
	document.addEventListener( 'click', ( event ) => {
		const button = event.target.closest( '.craftis-qty-stepper__btn' );
		if ( ! button ) {
			return;
		}

		const wrapper = button.closest( '.quantity' );
		const input = wrapper ? wrapper.querySelector( 'input.qty' ) : null;
		if ( ! input ) {
			return;
		}

		craftisStepQuantity( input, button.classList.contains( 'craftis-qty-stepper__btn--plus' ) ? 1 : -1 );
	} );
}

document.addEventListener( 'DOMContentLoaded', initQuantitySteppers );
